import { render, staticRenderFns } from "./BaseSvgIcons.vue?vue&type=template&id=daea80a2&scoped=true&"
import script from "./BaseSvgIcons.vue?vue&type=script&lang=js&"
export * from "./BaseSvgIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daea80a2",
  null
  
)

export default component.exports